<main class="data-view">
  @if (error) {
    <div class="empty-state error">{{ error }}</div>
  }

  @if (!loading && transfer && response) {
    <section class="dashboard-data-section">
      <header class="page-header">
        <div>
          <h1>{{ transfer.title }}</h1>
          <p>Dashboard chart and underlying data</p>
        </div>
        <span class="generated-date">
          <i class="fa-solid fa-calendar-days"></i>
          {{ transfer.request.dashboardModel.overview.filters?.createTimeEnd || currentTime | date : "yyyy-MM-dd" }}
        </span>
      </header>
      <section
        class="chart-card"
        [class.chart-card-with-summary]="chartSummary"
        >
        <div class="chart-visual">
          @if (transfer.chartImage) {
            <img
              class="dashboard-chart-image"
              [src]="transfer.chartImage"
              [alt]="transfer.title"
              />
          } @else {
            <div #chartContainer class="dashboard-chart-container"></div>
          }
        </div>
        @if (chartSummary; as summary) {
          <div class="chart-summary">
            <div class="chart-summary-header">
              <span>Status</span>
              <span>{{ summary.valueLabel }}</span>
              <span>% of total</span>
              <span></span>
            </div>
            <div class="chart-summary-rows">
              @for (item of summary.items; track item) {
                <div
                  class="chart-summary-row"
                  >
                  <span class="chart-summary-label">
                    <i
                      class="chart-summary-dot"
                      [style.background]="item.color"
                    ></i>
                    <span>{{ item.label }}</span>
                  </span>
                  <span class="chart-summary-number">{{ item.value }}</span>
                  <span class="chart-summary-number">
                    {{ getSummaryPercentage(item.value) | number : "1.2-2" }}%
                  </span>
                  <span class="chart-summary-track">
                    <i
                      class="chart-summary-bar"
                      [style.background]="item.color"
                      [style.width.%]="getSummaryPercentage(item.value)"
                    ></i>
                  </span>
                </div>
              }
            </div>
          </div>
        }
      </section>
      <app-dashboard-record-table
        [rows]="response.rows"
        [columns]="columns"
        [dataType]="transfer.request.dataType"
        [pageSize]="25"
        [total]="response.total"
        (pageChange)="loadPage($event)"
      ></app-dashboard-record-table>
    </section>
  }
</main>
